<template>
    <span class="scroll-anchor">
        <span class="scroll-anchor--elem" :id="id">&nbsp;</span>
    </span>
</template>

<script>
    export default {
        props: {
            id: {
                type: String,
                required: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?c6217dc2